import { getPublishTerms } from '../../../../shared/ServicePickerWidget/sagas/checkoutInfo/checkService/utils';
import {
  selectCurrentBet,
  selectIsAuctionSelected,
  selectMinimalBet,
} from '../../../../shared/ServicePickerWidget/selectors/auction';
import { selectIsAutoProlongChecked } from '../../../../shared/ServicePickerWidget/selectors/checkoutInfo';
import {
  selectActivePackage,
  selectActivePlacingType,
  selectActiveService,
  selectIsIncreaseToMinimalTopBet,
  selectIsWithoutServices,
  selectPlacingMoneySource,
  selectPublicationPeriod,
  selectPublicationTokens,
} from '../../../../shared/ServicePickerWidget/selectors/publishTerms';
import { selectTermsDurationInDays } from '../../../../shared/ServicePickerWidget/selectors/termsDurations';
import { mapPublishTerms } from '../../../../shared/ServicePickerWidget/thunks/offer/publishOffer/utils';
import { IExtendedContext } from '../../../types/extendedContext';

export const getPublishTermsHandler = (context: IExtendedContext) => () => {
  const state = context.store.getState();

  const { auction, calltracking } = state.servicePickerWidget;

  const service = selectActiveService(state);
  const servicePackage = selectActivePackage(state);
  const publicationPeriod = selectPublicationPeriod(state);
  const isAuctionSelected = selectIsAuctionSelected(state);
  const placingType = selectActivePlacingType(state);
  const isAutoprolongChecked = selectIsAutoProlongChecked(state);
  const moneySource = selectPlacingMoneySource(state);
  const increaseToMinimalTopBet = selectIsIncreaseToMinimalTopBet(state);
  const isWithoutServices = selectIsWithoutServices(state);
  const minimalBet = selectMinimalBet(state);
  const termsDurationInDays = selectTermsDurationInDays(state);
  const publicationTokens = selectPublicationTokens(state);
  const currentBet = selectCurrentBet(state);

  const terms = getPublishTerms({
    service,
    servicePackage,
    publicationPeriod,
    placingType,
    auction,
    isAuctionSelected,
    calltracking,
    moneySource,
    increaseToMinimalTopBet,
    isWithoutServices,
    minimalBet,
    termsDurationInDays,
    currentBet,
  });

  return mapPublishTerms({ isAutoprolongChecked, terms, publicationTokens });
};
